<div class="p-4 w-full" *ngIf="members">
    <header class="w-full flex flex-row justify-between items-center min-h-24 gap-12">
        <div class="flex justify-start items-center gap-12">
            <div class="flex flex-col gap-2">
                <span class="italic font-thin">{{ 'STATE' | translate }}</span>
                <div class="flex flex-row items-center gap-2">
                    <ng-container *ngIf="!hasPreemptiveRefusal">
                        <span [className]="'rounded-full w-3 h-3 bg-' + main_member?.status || ''"></span>
                        <span class="font-extrabold italic">{{ ('MEMBERS_STATUS.' + main_member?.status) | uppercase | translate}}</span>
                    </ng-container>
                    <ng-container *ngIf="hasPreemptiveRefusal">
                        <span [className]="'rounded-full w-3 h-3 bg-reject'"></span>
                        <span class="font-extrabold italic"> {{ 'MEMBERS_STATUS.REJECT' | translate }}</span>
                    </ng-container>
                </div>
                <div class="flex gap-2 items-center justify-center">
                    <span>{{ 'CURRENT_ORDER' | translate }}</span> <span class="block border-tw-primary border-2 px-2 py-1 text-tw-dark-primary"> {{ current_order }}</span>
                </div>
            </div>
            <div class="flex flex-col">
                <span class="italic font-thin">{{ 'APPROVAL_SENT' | translate }}</span>
                <span class="font-extrabold italic">{{ current_approval_number }} / {{ total_approval_number }}</span>
            </div>
        </div>
        <div class="flex flex-col" *ngIf="isCPP()">
           <button mat-icon-button [ngClass]="{'text-tw-primary': !locked}" [disabled]="locked" (click)="editMembersModal()">
                <mat-icon matTooltip="{{ 'EDIT_MEMBERS' | translate }}" matTooltipPosition="above">edit</mat-icon>
            </button>
        </div>
    </header>
    <app-members-proofreading [readonly]="readonly" [members]="members" [current_order]="current_order"></app-members-proofreading>
</div>